"use client";

import React, { useRef } from "react";
import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
// import { Link } from 'react-router-dom';
// import { HomeDetail } from "../services/HomeDetail";
import projectData from "@/data/projectList.json";
import Link from "next/link";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, Keyboard, Mousewheel } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import { useDispatch, useSelector } from "react-redux";
import {
  setInquiryPopup,
  setInquiryPopupObj,
} from "@/store/slices/inquirySlice";
import Image from "next/image";
import ExclusiveOpportunities from "@/components/ExclusiveOpportunities/ExclusiveOpportunities";
import Articles from "@/components/Articles/Articles";
import ClientTestimonials from "@/components/ClientTestimonials/ClientTestimonials";
import ProjectsSection from "@/components/ProjectsSection/ProjectsSection";
import { i } from "framer-motion/client";
import HomePageBannerNew from "@/components/HomePageBannerNew/HomePageBannerNew";
// import Seo from "../components/Seo";

export default function Home({
  // inquiryPopupObj,
  // setInquiryPopupObj,
  // inquiryPopup,
  // setInquiryPopup,
  homeDetailsData,
  // propertylist,
  recentBlogs,
  aboutUsData,
}) {
  const [isMobilescreen, setMobileScreen] = useState(false);
  const section2Ref = useRef(null);
  const scrollToSection = (ref) => {
    if (!ref?.current) return;

    ref.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };
  //   const [homeDetailsData, setHomeDetail] = useState(homeDetails || null);
  const propertylist = useSelector((state) => state.inquiry.propertyList);
  const dispatch = useDispatch();
  useEffect(() => {
    const checkScreen = () => {
      setMobileScreen(window.innerWidth <= 991);
    };

    checkScreen();

    window.addEventListener("resize", checkScreen);

    return () => {
      window.removeEventListener("resize", checkScreen);
    };
  }, []);

  if (!homeDetailsData) {
    return <div>Error loading data</div>;
  }
  const certifications = [
    "/images/home/certification/gihed.png",
    "/images/home/certification/gjepc.png",
    "/images/home/certification/igbc.png",
    "/images/home/certification/jito.png",
  ];
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);
  const interleaveOffset = 0.5;
  const mergedData = propertylist.map((item) => {
    const mobileItem = projectData.list.find(
      (p) => Number(p.project_id) === Number(item.project_id),
    );

    return {
      ...item,
      Mobilebanner: mobileItem?.Mobilebanner || "",
      project_status: mobileItem?.project_status || "",
    };
  });
  console.log(mergedData);
  const bannerList = [
    {
      image: "/images/home/new-banners/stark-torre.jpg",
      title: "Building Beyond Spaces",
    },
    {
      image: "/images/home/new-banners/palm.jpg",
      title: "Building Beyond Spaces",
    },
    {
      image: "/images/home/new-banners/parva.jpg",
      title: "Building Beyond Spaces",
    },
    {
      image: "/images/home/new-banners/sarvam.jpg",
      title: "Building Beyond Spaces",
    },
  ];
  const bannerListMObile = [
    {
      image: "/images/home/new-banners/mobile/stark-torre.jpg",
      title: "Building Beyond Spaces",
    },
    {
      image: "/images/home/new-banners/mobile/palm.jpg",
      title: "Building Beyond Spaces",
    },
    {
      image: "/images/home/new-banners/mobile/parva.jpg",
      title: "Building Beyond Spaces",
    },
    {
      image: "/images/home/new-banners/mobile/sarvam.jpg",
      title: "Building Beyond Spaces",
    },
  ];
  function Counter({ value }) {
    const { ref, inView } = useInView({
      triggerOnce: true,
      threshold: 0.3,
    });

    const number = parseInt(value.replace(/,/g, ""));
    const suffix = value.replace(/[0-9,]/g, "");

    return (
      <div ref={ref}>
        <h2 className="white-color highlights-counter">
          {inView ? (
            <span className="white-color highlights-counter">
              <CountUp start={0} end={number} duration={2.5} />
              {suffix}
            </span>
          ) : (
            <span className="white-color">0{suffix}</span>
          )}
        </h2>
      </div>
    );
  }

  return (
    <>
      <div
        className="reecosys-template-page-wrapper"
        id="home-page-wrapper-reecosys-template"
        style={{ minHeight: "100vh" }}
      >
        {/* <section
          className="relative"
          id="home-banner-nb-buildcon"
          style={{ overflow: "hidden" }}
        >
          <motion.div
            className="home-banner-nb-new relative"
            style={{ aspectRatio: 96 / 67 }}
            initial={{ scale: 1.08, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{
              duration: 1.2,
              ease: "easeOut",
            }}
          >
            <Image
              src="/images/home/nb-buildcon-banner.jpg"
              fill
              className=""
              alt="Building Beyond Spaces"
            />
          </motion.div>
          <div
            className="scroll-to-bottom"
            onClick={() => scrollToSection(section2Ref)}
          >
            <img src="/images/new-icons/scroll-bottom.svg" alt="" />
          </div>
          <div className="banner-title-new-home-wrapper">
            <div className="banner-title-big main-container">
              <motion.h1
                className="white-color"
                initial={{
                  opacity: 0,
                  y: 80,
                }}
                animate={{
                  opacity: 1,
                  y: 0,
                }}
                transition={{
                  duration: 0.9,
                  delay: 0.4,
                  ease: "easeOut",
                }}
              >
                Building Beyond Spaces
              </motion.h1>
            </div>
          </div>
        </section> */}
        <HomePageBannerNew
          banners={bannerList}
          bannersMobile={bannerListMObile}
          scrollToSection={scrollToSection}
          section2Ref={section2Ref}
        />

        <section
          ref={section2Ref}
          className="reecosys-template-section section-paddinglarge relative"
          id="reecosys-template-home-section-2"
        >
          <div className="mini-container">
            <div className="overview-wrapper-grid-new">
              <motion.div
                className="inner-flex inner-flex-medium"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
              >
                {homeDetailsData?.home_title && (
                  <motion.div
                    className="section-title"
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.1 }}
                    viewport={{ once: true }}
                  >
                    <h2 className="white-color web70width">
                      {homeDetailsData.home_title}
                    </h2>
                  </motion.div>
                )}

                {homeDetailsData?.home_overview && (
                  <motion.div
                    className="section-paragraph"
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    viewport={{ once: true }}
                  >
                    <p className="white-color80">
                      {homeDetailsData.home_overview}
                    </p>
                  </motion.div>
                )}

                {homeDetailsData?.highlights_array?.length > 0 && (
                  <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.7, delay: 0.3 }}
                    viewport={{ once: true }}
                  >
                    <div
                      className={`about-btn-home outline-div-button button-div ${isMobilescreen === false ? "wfc" : ""
                        }`}
                    >
                      <Link href="/about-us">
                        <div>
                          <button className="reecosys-template-button button-style-white w100">
                            <p>Know More</p>
                            <span className="material-symbols-outlined">
                              arrow_forward
                            </span>
                          </button>
                        </div>
                      </Link>
                    </div>
                  </motion.div>
                )}
              </motion.div>

              <motion.div
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
              >
                {homeDetailsData?.highlights_array?.length > 0 && (
                  <div className="highlights-for-homes">
                    <div className="highlights-grid inner-flex inner-flex-medium">
                      {homeDetailsData.highlights_array.map((data, index) => (
                        <div key={index}>
                          <div className="banner-title-big">
                            <Counter value={data.name} />
                          </div>
                          <div className="section-paragraph">
                            <p className="white-color">{data.tag_line}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </motion.div>
            </div>
          </div>
        </section>
        <ProjectsSection propertylist={propertylist} mergedData={mergedData} />
        <section
          className="parshwa-shah-home-page-quote section-padding"
          id="parshwahomequote"
        >
          <div className="main-container">
            <div className="parshwa-quote-grid-wrapper">
              {/* Image Animation */}
              <motion.div
                className="parshwa-quote-wrapper-img relative"
                style={{ aspectRatio: 19 / 22 }}
                initial={{ opacity: 0, y: 80 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.9 }}
                viewport={{ once: true }}
              >
                <Image
                  src="/images/home/parshwa-shah-quote-home.jpg"
                  fill
                  alt="Building Beyond Spaces"
                />
              </motion.div>

              {/* Content Animation */}
              <motion.div
                className="parshwa-quote-content-wrapper"
                initial={{ opacity: 0, y: 80 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.9 }}
                viewport={{ once: true }}
              >
                <motion.div
                  className="section-paragraph2"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{
                    duration: 0.7,
                    delay: 0.2,
                  }}
                  viewport={{ once: true }}
                >
                  <p>
                    “ We build thoughtfully, where{" "}
                    <span>architecture meets emotion</span> and design meets
                    detail. Our commitment to{" "}
                    <span>quality and sustainability</span> is not just a
                    promise <span>it's our philosophy.</span> ”
                  </p>
                </motion.div>

                <motion.div
                  className="parshwa-caligraphy"
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  transition={{
                    duration: 1,
                    delay: 0.6,
                  }}
                  viewport={{ once: true }}
                >
                  <img src="/images/home/parshwa-shah-sign.png" alt="" />
                </motion.div>
              </motion.div>
            </div>
          </div>
        </section>
        {/* <section className="section-pending philosophy-sec">
          <div className="mini-container">
            <div className="inner-flex inner-flex-medium text-center">
              <p className="white-color uppercase medium-fonts">
                “ We build <span className="light-fonts"> thoughtfully </span>,
                where architecture meets emotion and design meets detail. Our
                commitment to <span className="light-fonts"> quality </span> and{" "}
                <span className="light-fonts"> sustainability </span> is not
                just a <span className="light-fonts"> promise </span>
                it's our <span className="light-fonts"> philosophy</span>. ”
              </p>
              <div className="parshwaShahImg">
                <img src="/images/home/parshwaShah.svg" alt="" />
              </div>
            </div>
          </div>
        </section> */}
        <ExclusiveOpportunities />
        <section className="section-padding" id="certifications-associations">
          <div className="mini-container">
            <div className="inner-flex inner-flex-medium">
              <motion.div
                className="section-title section-content inner-flex inner-flex-common"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7 }}
                viewport={{ once: true }}
              >
                <h2>Certifications & Associations</h2>

                <p>
                  Our credibility is reinforced through industry-recognized
                  certifications and <br className="hide-tab-mobile" />
                  valued associations that uphold our standards.
                </p>
              </motion.div>

              <div className="certifications-grid">
                {aboutUsData?.group_company?.companies?.map((item, index) => (
                  <motion.div
                    key={index}
                    className="certifications-item relative"
                    initial={{ opacity: 0, y: 60 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{
                      duration: 0.6,
                      delay: index * 0.1,
                    }}
                    viewport={{ once: true }}
                  >
                    <Link href={item.url ? item.url : "#"} target="_blank">
                      <img
                        src={`${item.image_main}&w=600&q=100`}
                        alt={`certification-${index}`}
                        className="img-fluid"
                      />
                    </Link>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </section>
        {/* <ClientTestimonials /> */}
        <div className="">
          <Articles recentBlogs={recentBlogs} />
        </div>
        <section className="testimonial-section section-padding">
          <div className="main-container-fluid">
            <div className="inner-flex inner-flex-medium">
              <motion.div
                className="section-title"
                initial={{ opacity: 0, y: 25 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7 }}
                viewport={{ once: true, amount: 0.4 }}
              >
                <h2>{homeDetailsData?.testimonial?.title}</h2>
              </motion.div>

              {/* Desktop Grid */}
              <motion.div
                className="testimonial-grid testimonial-desktop"
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, amount: 0.15 }}
                variants={{
                  hidden: {},
                  show: {
                    transition: {
                      staggerChildren: 0.18,
                    },
                  },
                }}
              >
                {homeDetailsData?.testimonial?.reviews?.map((item, index) => (
                  <motion.div
                    className="testimonial-card"
                    key={index}
                    variants={{
                      hidden: { opacity: 0, y: 70 },
                      show: {
                        opacity: 1,
                        y: 0,
                        transition: {
                          duration: 0.8,
                          ease: "easeOut",
                        },
                      },
                    }}
                  >
                    <div className="quote-icon">
                      <img src="/images/icon/quote.svg" alt="" />
                    </div>

                    <div className="section-content">
                      <p>{item.description}</p>
                    </div>

                    {/* <div className="testimonial-user">
                      <span></span>
                      <h4>{item.name}</h4>
                    </div> */}
                  </motion.div>
                ))}
              </motion.div>

              {/* Mobile Swiper */}
              <div className="testimonial-mobile-slider">
                <Swiper
                  modules={[Pagination]}
                  slidesPerView={1}
                  spaceBetween={20}
                  pagination={{ clickable: true }}
                >
                  {homeDetailsData?.testimonial?.reviews?.map((item, index) => (
                    <SwiperSlide key={index}>
                      <div className="testimonial-card">
                        <div className="quote-icon">
                          <img src="/images/icon/quote.svg" alt="" />
                        </div>

                        <div className="section-content">
                          <p>{item.description}</p>
                        </div>

                        {/* <div className="testimonial-user">
                          <span></span>
                          <h4>{item.name}</h4>
                        </div> */}
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
